import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose, durationMs }) => {
  useEffect(() => {
    // Longer messages (success disclaimers) need more reading time
    const length = typeof message === 'string' ? message.length : 0;
    const autoMs =
      durationMs != null
        ? durationMs
        : type === 'error'
          ? 8000
          : length > 120
            ? 10000
            : 5000;
    const timer = setTimeout(() => {
      onClose();
    }, autoMs);

    return () => clearTimeout(timer);
  }, [onClose, message, type, durationMs]);

  const isSuccess = type === 'success';
  const bgColor = isSuccess
    ? 'bg-hope-green border-hope-green/40'
    : 'bg-red-600 border-red-400/40';

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className={`fixed top-4 right-4 left-4 sm:left-auto ${bgColor} text-white px-5 py-4 rounded-lg shadow-2xl z-50 animate-slide-in border max-w-md sm:max-w-sm ml-auto`}
    >
      <div className="flex items-start justify-between gap-3">
        <p className="font-medium text-sm sm:text-base leading-snug">{message}</p>
        <button
          type="button"
          onClick={onClose}
          className="text-white/90 hover:text-white font-bold text-xl leading-none flex-shrink-0"
          aria-label="Dismiss notification"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;
